import { EmailBuilderBlock } from "./emailBuilderData";

export type MoveEmailBuilderBlockInput = {
  blocks: EmailBuilderBlock[];
  blockId: string;
  targetIndex: number;
};

/**
 * Moves one email-builder block without mutating the persisted block array.
 * Block IDs and settings stay intact so selection, save/reload, and rendered
 * email order all continue to use the same canonical builder state.
 */
export const moveEmailBuilderBlock = ({
  blocks,
  blockId,
  targetIndex,
}: MoveEmailBuilderBlockInput): EmailBuilderBlock[] => {
  const currentIndex = blocks.findIndex((block) => block.id === blockId);
  const boundedTargetIndex = Math.max(0, Math.min(targetIndex, blocks.length - 1));

  if (
    currentIndex < 0 ||
    blocks.length < 2 ||
    currentIndex === boundedTargetIndex
  ) {
    return blocks;
  }

  const nextBlocks = [...blocks];
  const [movedBlock] = nextBlocks.splice(currentIndex, 1);
  nextBlocks.splice(boundedTargetIndex, 0, movedBlock);

  return nextBlocks;
};

